module.exports = __webpack_public_path__ + "img/12_14.5f8a2437.png";